export default __webpack_public_path__ + "static/media/bench.d97be8a5.jpg";